export default __webpack_public_path__ + "static/media/car-icon.ac86829c.svg";